<template>
  <div class="tabs" v-if="displayTabs()">
    <ul
      id="tabs"
      class="nav nav-tabs tabs-toggle"
      role="tablist"
      v-if="data.content"
    >
      <li
        class="nav-item"
        v-for="(item, index) in data.content"
        :key="index"
        v-if="
          !(item.hide || false) &&
            ((item == data.content.seo && isAuthorizeSeo()) ||
              item != data.content.seo)
        "
      >
        <a
          @click="activate(data.content, item)"
          :id="`content-tab${index}`"
          :class="item.active ? 'active' : ''"
          aria-controls="content-panel"
          aria-expanded="true"
        >
          {{ item.title }}
        </a>
      </li>
    </ul>

    <div
      v-if="
        $languages != undefined &&
          $languages != null &&
          $languages.length > 1 &&
          contentActive.hasLanguage
      "
    >
      <b-dropdown class="dropdown-tabs">
        <div slot="button-content" class="dropdown-toggle button">
          <i :class="languageActive.flag" aria-hidden="true"></i>
          {{ languageActive.name }}
          <i class="fa fa-angle-down" aria-hidden="true"></i>
        </div>
        <b-dropdown-item
          v-for="item in $languages"
          @click="activateLanguage(item.id)"
          :title="`${item.name} pointer`"
          :key="item.id"
        >
          {{ item.name }}</b-dropdown-item
        >
      </b-dropdown>
    </div>
  </div>
</template>
<script>
import languages from "@mixins/languages.js";
import compte from "@mixins/compte.js";
export default {
  name: "volcan-card-tabs",
  props: ["data"],
  mixins: [languages, compte],
  data: function() {
    return {};
  },
  computed: {
    languageActive() {
      var id = this.data.languageIdActive;
      var language = {};
      var languages = [];
      if (this.$languages.length > 0) {
        languages = this.$languages.filter(lang => lang.id === id);
      }
      if (languages.length > 0) {
        language = languages[0];
      }
      return language;
    },
    contentActive() {
      var contentActive = {};
      Object.keys(this.data.content).forEach((key, index) => {
        if (this.data.content[key].active) {
          contentActive = this.data.content[key];
        }
      });
      return contentActive;
    }
  },
  beforeMount() {
    if (
      this.$languages &&
      this.$languages.length > 0 &&
      this.data.languageIdActive == 0
    ) {
      this.setLanguageId();
    }
  },
  watch: {
    $languages: {
      handler: function(val, oldVal) {
        this.setLanguageId();
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    displayTabs() {
      var count = 0;

      Object.keys(this.data.content).forEach(item => {
        if (
          item == "seo" &&
          this.isAuthorizeSeo() &&
          !this.data.content[item].hide
        ) {
          count += 1;
        }

        if (item != "seo" && !this.data.content[item].hide) {
          count += 1;
        }
      });
      var hasOneTabLanguage = false;
      Object.keys(this.data.content).forEach((key, index) => {
        if (this.data.content[key].hasLanguage) {
          hasOneTabLanguage = true;
        }
      });
      return count > 1 || (this.$languages.length > 1 && hasOneTabLanguage);
    },
    setLanguageId() {
      this.data.languageIdActive = this.getCulture(this.$i18n.locale()).id;
    },
    activate(list, item) {
      Object.keys(list).forEach((key, index) => {
        list[key].active = false;
      });
      item.active = true;
    },
    activateLanguage(id) {
      this.data.languageIdActive = id;
    }
  }
};
</script>
<style lang="scss">
@import "../../../Shared/Layout/Assets/sass/base/_variables.scss";

.dropdown-tabs {
  float: right;
  .btn {
    padding: 0;
    border-radius: 0;
    border-left: 1px solid $white;
  }

  .button {
    padding: 7px 23px;
    border-left: 1px solid $white;
    &:hover {
      border: none;
    }

    &:focus {
      border: none;
    }

    &:active {
      border: none;
    }
  }

  .dropdown-menu {
    border: none;
    min-width: 0px;
    .dropdown-item {
      background: gray;
      color: white;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/card/card-tabs.vue